import { render, staticRenderFns } from "./addOrEditAdmin.vue?vue&type=template&id=53fad2b4&"
import script from "./addOrEditAdmin.vue?vue&type=script&lang=js&"
export * from "./addOrEditAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports